import React from "react";

export function FilterChip({
  label,
  active,
  onClick,
  count,
  icon,
  disabled = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`flex-shrink-0 inline-flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border transition whitespace-nowrap ${
        active
          ? "bg-green-700 text-white border-green-700 dark:bg-green-600 dark:border-green-600"
          : "bg-white dark:bg-neutral-800 text-gray-700 dark:text-gray-200 border-gray-300 dark:border-neutral-700 hover:border-green-500"
      } ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}
    >
      {icon}
      {label}
      {count > 0 ? <span className="ml-1.5 opacity-80">({count})</span> : null}
    </button>
  );
}
